import React from "react";
import MaterialTable from "material-table";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'

import Tooltip from "@tippyjs/react";

import Helper from "../../../../Helper";
import { getTrans as t } from "../../../../Localization/translations";
function AmortizationScheduleArrears({
  setarrears,
  contracttype,
  financedamount,
  deposit_amount,
  contractiir,
  paymentamount,
  residual,
  numberofpayment,
  paymentfrequency,
  contract_term,
  feesontime,
  totalIncome,
  totalRent,
  key,
  totaldepreciation,
  amortError,
  baseRate,
  margin,
  InterestRateType

}) {
  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
      if (columnDef.field === 'periodicpaymentAmount') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'beginBV') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'income') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'paymentAmount') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'capitalRecovery') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'rentalincome') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'bookDepericiation') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'endBV') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else if (columnDef.field === 'incomeRecognized') {
        alignmentStyles[index] = { halign: 'right' };
      }
      else {
        alignmentStyles[index] = { halign: 'left' };
      }
    });
    return alignmentStyles;
  }
  // A Line of Credit is lending too: same "Interest" wording and table as Loan.
  const isLoanLike = contracttype === "Loan" || contracttype === "Line of Credit";
  const amortNote =
    contracttype === "Line of Credit"
      ? "Amortization Schedule will be generated after Disbursements"
      : "Actual Amortization Schedule will be generated on contract activation";
  console.log("amortError in schedule:", amortError);
  return (
    <>
      <div className="pt-2">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="col-md-10">
                {/* <div className="col text-left"></div> */}
                {/* <div className="row"> */}
                <div className=" row">
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <span className=" sub-title tc">
                      {t("Financed Amount")}{" "}
                      <Tooltip content={t("Amountfinanced_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </span>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {/* {financedamount === 0 */}
                        {/* ? */}
                        {Helper.Amount(financedamount)}
                        {/* : Helper.Amount(financedamount - deposit_amount)} */}
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    {/* <span className="sub-title tc">
                        {t("Total Rent")}{" "}
                        <Tooltip content={t("TotalRent_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </span> */}
                    <label className="sub-title tc">
                      {isLoanLike
                        ? t("Total Payment")
                        : t("Total Rent")}{" "}

                      <Tooltip
                        content={
                          isLoanLike
                            ? t("Total Payment")
                            : t("TotalRent_Tooltip")
                        }
                      >
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {totalRent !== '' ? Helper.Amount(totalRent) : Helper.Amount(0)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className=" row">
                  {/* <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <label className=" sub-title tc">
                            {t("Tax Rate Fees")}{" "}
                            <Tooltip content={t("TotalRecurringFees_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                            <span className="col-lg-8 party-detail-font">
                              {Helper.Amount(tax_rate_fee)}
                            </span>
                          </div>
                        </div> */}
                  {/* <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}> */}
                    {/* <span className=" sub-title tc">
                      {t("Total One Time Fees")}{" "}
                      <Tooltip content={t("TotalOneTimeFees_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </span> */}
                    {/* <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {Helper.Amount(feesontime)}
                      </span>
                    </div> */}
                  {/* </div> */}
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <span className="sub-title tc">
                      {t("Total Income")}{" "}
                      <Tooltip content={t("TotalRecurringFees_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </span>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {Helper.Amount(totalIncome)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className=" row">
                  {
                    InterestRateType === "Fixed" ? "" 
                    :
                   <>
                    {isLoanLike ?
                    
                      <>
                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        <span className="sub-title tc">
                          {t("Base Rate")}{" "}
                          <Tooltip content={t("BaseRate_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </span>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <span className="party-detail-font">
                            {Helper.Amount(baseRate)}
                          </span>
                        </div>
                      </div>
                  
                      
                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        <span className="sub-title tc">
                          {t("Margin")}{" "}
                          <Tooltip content={t("Margin_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </span>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <span className="party-detail-font">
                            {Helper.Amount(margin)}
                          </span>
                        </div>
                      </div>
                      </>
                      :""
}
                    </>
}


                  {
                    contracttype === "Rental" ?
                      "" :
                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        <span className="sub-title tc">
                          {t("IRR/Interest p.a.")}{" "}
                          <Tooltip content={t("IRR/Interestp.a_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </span>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <span className="party-detail-font">
                            {Helper.Amount(contractiir)}
                          </span>
                        </div>
                      </div>
                  }
                 
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <span className="sub-title tc">
                      {t("Term (Months)")}{" "}
                      <Tooltip content={t("Term_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </span>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {contract_term}
                      </span>
                    </div>
                  </div>
                  {
                    contracttype === "Rental" ?
                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        <span className="sub-title tc">
                          {t("Total Depreciation")}{" "}
                          <Tooltip content={t("Total Depreciation")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </span>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <span className="party-detail-font">
                            {Helper.Amount(totaldepreciation)}
                          </span>
                        </div>
                      </div> :
                      ""
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="col-lg-12 col-md-12 mb-md-0 mb-4 mt-4">
          <div className="card-body px-0 pb-2">
            <div className="table-responsive">
              {
                contracttype === "Rental" ?
                  <MaterialTable
                    style={{
                      backgroundColor: "var(--bs-table-bg)",
                      borderBottomWidth: "1px",
                      boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                    }}
                    title={<> <span className="required">Amortization Schedule</span> -{" "}
                      <span style={{ fontSize: "14px" }}>
                        {amortNote}
                      </span></>}
                    columns={[
                      {
                        title: `${t("Date")}`,
                        field: "paymentDate",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("Date")}</div>
                            <div> {Helper.DateNormal(rowData.paymentDate)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Peridic Payment Amount")}`,
                        field: "periodicpaymentAmount",
                        render: (rowData) => (
                          <>
                            <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                            >
                              {t("Periodic Payment Amount")}
                            </div>
                            <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                              {" "}
                              {rowData.periodicpaymentAmount >= 0
                                ? Helper.Amount(rowData.periodicpaymentAmount)
                                : ""}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("Start Date")}`,
                        field: "startDate",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("Start Date")}</div>
                            <div>{Helper.DateNormal(rowData.startDate)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("End Date")}`,
                        field: "endDate",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("End Date")}</div>
                            <div>{Helper.DateNormal(rowData.endDate)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("No Of Days")}`,
                        field: "noOfDays",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("No Of Days")}</div>
                            <div>{rowData.noOfDays}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },

                      {
                        title: t("OP Begin"),
                        field: "beginBV",
                        render: (rowData) => (
                          <>
                            <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                            >
                              {t("OP Begin")}
                            </div>
                            <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.beginBV)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: t("Income Date"),
                        field: "incomeDate",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">{t("Income Date")}</div>
                            <div>{Helper.DateNormal(rowData.incomeDate)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: t("Rental Income"),
                        field: "rentalincome",
                        render: (rowData) => (
                          <>
                            <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                            >
                              {t("Rental Income")}
                            </div>
                            <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.rentalincome)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: t("Book Depreciation"),
                        field: "bookDepericiation",
                        render: (rowData) => (
                          <>
                            <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                            >
                              {t("Book Depreciation")}
                            </div>
                            <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.bookDepericiation)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: t("OP End"),
                        field: "endBV",
                        render: (rowData) => (
                          <>
                            <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                            >
                              {t("OP End")}
                            </div>
                            <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.endBV)}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("Income Recognized")
                          }`,
                        field: "incomeRecognized",
                        render: (rowData) => (
                          <>
                            <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                            >
                              {t("Income Recognized")}
                            </div>
                            <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                              {rowData.incomeRecognized >= 0
                                ? Helper.Amount(rowData.incomeRecognized)
                                : ""}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                    ]}
                    data={setarrears}
                    options={{
                      headerStyle: {
                        backgroundColor: "white",
                        color: "#245C7F",
                        fontSize: 10,
                      },
                      rowStyle: (rowData, index) => {
                        if (index % 2) {
                          return { backgroundColor: "#fff" };
                        }
                      },
                      sorting: true,
                      search: false,
                      toolbar: true,
                      paging: true,
                      pageSize: 10,
                      emptyRowsWhenPaging: false,
                      pageSizeOptions: [10, 15, 20, 50],
                      paginationType: "stepped",
                      showFirstLastPageButtons: false,
                      exportAllData: true,
                      exportButton: true,
                      exportFileName: "Amortization Schedule",
                      exportCsv: async (columns, data) => {
                        try {
                          const title = "Amortization Schedule";
                          const currentDate = new Date().toLocaleDateString();

                          const csvContentWithInfo = `${title}\n Date: ${currentDate}\n \n\n`;
                          const csvColumns = columns.map(columnDef => columnDef.title);
                          const csvData = data.map(rowData => {
                            const rowDataArray = columns.map(columnDef => {
                              if (columnDef.field === "periodicpaymentAmount") {
                                return (
                                  rowData.periodicpaymentAmount !== 0
                                    ? Helper.Amount(rowData.periodicpaymentAmount)
                                    : ""
                                );
                              } else if (columnDef.field === 'beginBV') {
                                return (rowData.beginBV !== 0
                                  ? Helper.Amount(rowData.beginBV) : ''
                                )
                              } else if (columnDef.field === 'rentalincome') {
                                return (rowData.rentalincome !== 0
                                  ? Helper.Amount(rowData.rentalincome) : ''
                                )
                              }
                              else if (columnDef.field === 'bookDepericiation') {
                                return (rowData.bookDepericiation !== 0
                                  ? Helper.Amount(rowData.bookDepericiation) : ''
                                )
                              }
                              else if (columnDef.field === 'endBV') {
                                return (rowData.endBV !== 0
                                  ? Helper.Amount(rowData.endBV) : ''
                                )
                              }
                              else if (columnDef.field === 'incomeRecognized') {
                                return (rowData.incomeRecognized !== 0
                                  ? Helper.Amount(rowData.incomeRecognized) : ''
                                )
                              }
                              else {
                                return rowData[columnDef.field];
                              }
                            });
                            return rowDataArray;
                          });

                          const csvRows = [csvColumns, ...csvData];
                          const csvContent = `${csvContentWithInfo}${csvRows.map(row => {
                            return row.map(field => {
                              if (field === null || field === undefined) {
                                return '""'; // Represent null values as an empty string in double quotes
                              }
                              field = String(field);
                              if (field.includes(',')) {
                                return `"${field}"`;
                              } else {
                                return field;
                              }
                            }).join(',');
                          }).join('\n')}`;
                          // const csvContent = csvRows.map(row => row.join(',')).join('\n');

                          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                          const link = document.createElement('a');
                          link.href = URL.createObjectURL(blob);
                          link.download = 'Amortization Schedule.csv';
                          link.style.display = 'none';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        } catch (error) {
                          console.error("Error exporting CSV:", error);

                          // Add this line to see the detailed error information in the console
                          console.error(error.stack);
                        }
                      },
                      exportPdf: (data, columns) => {
                        const doc = new jsPDF();
                        doc.setFont("helvetica", "bold");
                        doc.setFontSize(16);

                        const title = "Amortization Schedule";
                        doc.text(title, 14, 10);

                        doc.setFontSize(12);
                        doc.setFont("helvetica", "normal");
                        const currentDate = new Date().toLocaleDateString();
                        doc.text(`Date : ${currentDate}`, 14, 15);
                        const space = 22; // Adjust the space value as needed
                        const tableStartY = 5 + space;
                        const columnTitles = data.map(
                          (columnDef) => columnDef.title
                        );
                        const pdfData = columns.map((rowData) => {
                          const rowDataArray = data.map((columnDef) => {
                            if (columnDef.field === "periodicpaymentAmount") {
                              return (
                                rowData.periodicpaymentAmount !== 0
                                  ? Helper.Amount(rowData.periodicpaymentAmount)
                                  : ""
                              );
                            } else if (columnDef.field === 'beginBV') {
                              return (rowData.beginBV !== 0
                                ? Helper.Amount(rowData.beginBV) : ''
                              )
                            } else if (columnDef.field === 'rentalincome') {
                              return (rowData.rentalincome !== 0
                                ? Helper.Amount(rowData.rentalincome) : ''
                              )
                            }
                            else if (columnDef.field === 'bookDepericiation') {
                              return (rowData.bookDepericiation !== 0
                                ? Helper.Amount(rowData.bookDepericiation) : ''
                              )
                            }
                            else if (columnDef.field === 'endBV') {
                              return (rowData.endBV !== 0
                                ? Helper.Amount(rowData.endBV) : ''
                              )
                            }
                            else if (columnDef.field === 'incomeRecognized') {
                              return (rowData.incomeRecognized !== 0
                                ? Helper.Amount(rowData.incomeRecognized) : ''
                              )
                            }
                            else {
                              return rowData[columnDef.field];
                            }
                          });
                          return rowDataArray;
                        });
                        // doc.autoTable({
                        autoTable(doc, {
                          head: [columnTitles],
                          body: pdfData,
                          startY: tableStartY, // Adjust the vertical starting position of the table
                          styles: {
                            cellPadding: 2, // Adjust cell padding
                            fontSize: 5, // Adjust font size
                          },
                          columnStyles: getAlignmentStyles(data) // Apply column alignment styles

                        });

                        doc.save(`Amortization Schedule.pdf`);
                      },
                      actionsColumnIndex: -1,
                    }}
                  />
                  :
                  isLoanLike ?
                    <MaterialTable
                      style={{
                        backgroundColor: "var(--bs-table-bg)",
                        borderBottomWidth: "1px",
                        boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                      }}
                      title={<> <span className="required">Amortization Schedule</span> -{" "}
                        <span style={{ fontSize: "14px" }}>
                          {amortNote}
                        </span></>}
                      columns={[
                        {
                          title: `${t("Date")}`,
                          field: "paymentDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("Date")}</div>
                              <div> {Helper.DateNormal(rowData.paymentDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("Payment Amount")}`,
                          field: "paymentAmount",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {t("Payment Amount")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                {" "}
                                {rowData.paymentAmount !== 0
                                  ? Helper.Amount(rowData.paymentAmount)
                                  : ""}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${t("Start Date")}`,
                          field: "startDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("Start Date")}</div>
                              <div>{Helper.DateNormal(rowData.startDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("End Date")}`,
                          field: "endDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("End Date")}</div>
                              <div>{Helper.DateNormal(rowData.endDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("No Of Days")}`,
                          field: "noOfDays",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("No Of Days")}</div>
                              <div>{rowData.noOfDays}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${isLoanLike
                            ? t("Interest Date")
                            : t("Income Date")
                            }`,
                          field: "incomeDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {isLoanLike
                                  ? t("Interest Date")
                                  : t("Income Date")}
                              </div>
                              <div>{Helper.DateNormal(rowData.incomeDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${isLoanLike
                            ? t("Begining Principal")
                            : t("Begin Bv")
                            }`,
                          field: "beginBV",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {isLoanLike
                                  ? t("Begining Principal")
                                  : t("Begin Bv")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.beginBV)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${isLoanLike ? t("Interest") : t("Income")
                            }`,
                          field: "income",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {isLoanLike
                                  ? t("Interest")
                                  : t("Income")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.income)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${t("Principal")}`,
                          field: "capitalRecovery",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {t("Principal")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                {Helper.Amount(rowData.capitalRecovery)}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },

                        {
                          title: `${isLoanLike
                            ? t("Ending Principal")
                            : t("End Bv")
                            }`,
                          field: "endBV",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {isLoanLike
                                  ? t("Ending Principal")
                                  : t("End Bv")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.endBV)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${isLoanLike
                            ? t("Interest Recognized")
                            : t("Income Recognized")
                            }`,
                          field: "incomeRecognized",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {isLoanLike
                                  ? t("Interest Recognized")
                                  : t("Income Recognized")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                {rowData.incomeRecognized !== 0
                                  ? Helper.Amount(rowData.incomeRecognized)
                                  : ""}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                      ]}
                      data={setarrears}
                      options={{
                        headerStyle: {
                          backgroundColor: "white",
                          color: "#245C7F",
                          fontSize: 10,
                        },
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: "#fff" };
                          }
                        },
                        sorting: true,
                        search: false,
                        toolbar: true,
                        paging: true,
                        pageSize: 10, // make initial page size
                        emptyRowsWhenPaging: false, // To avoid of having empty rows
                        pageSizeOptions: [10, 15, 20, 50],
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,
                        exportAllData: true,
                        exportButton: true,
                        exportFileName: "Amortization Schedule",
                        exportCsv: async (columns, data) => {
                          try {
                            const title = "Amortization Schedule";
                            const currentDate = new Date().toLocaleDateString();

                            const csvContentWithInfo = `${title}\n Date: ${currentDate}\n \n\n`;

                            const csvColumns = columns.map(columnDef => columnDef.title);
                            const csvData = data.map(rowData => {
                              const rowDataArray = columns.map(columnDef => {
                                if (columnDef.field === "paymentAmount") {
                                  return (
                                    rowData.paymentAmount !== 0
                                      ? Helper.Amount(rowData.paymentAmount)
                                      : ""
                                  );
                                } else if (columnDef.field === 'beginBV') {
                                  return (rowData.beginBV !== 0
                                    ? Helper.Amount(rowData.beginBV) : ''
                                  )
                                }
                                else if (columnDef.field === 'income') {
                                  return (rowData.income !== 0
                                    ? Helper.Amount(rowData.income) : ''
                                  )
                                } else if (columnDef.field === 'capitalRecovery') {
                                  return (rowData.capitalRecovery !== 0
                                    ? Helper.Amount(rowData.capitalRecovery) : ''
                                  )
                                } else if (columnDef.field === 'endBV') {
                                  return (rowData.endBV !== 0
                                    ? Helper.Amount(rowData.endBV) : ''
                                  )
                                } else if (columnDef.field === 'incomeRecognized') {
                                  return (rowData.incomeRecognized !== 0
                                    ? Helper.Amount(rowData.incomeRecognized) : ''
                                  )
                                }
                                else {
                                  return rowData[columnDef.field];
                                }
                              });
                              return rowDataArray;
                            });

                            const csvRows = [csvColumns, ...csvData];
                            const csvContent = `${csvContentWithInfo}${csvRows.map(row => {
                              return row.map(field => {
                                if (field === null || field === undefined) {
                                  return '""'; // Represent null values as an empty string in double quotes
                                }
                                if (typeof field === 'string' && field.includes(',')) {
                                  return `"${field}"`;
                                } else {
                                  return field;
                                }
                              }).join(',');
                            }).join('\n')}`;
                            // const csvContent = csvRows.map(row => row.join(',')).join('\n');

                            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                            const link = document.createElement('a');
                            link.href = URL.createObjectURL(blob);
                            link.download = 'Amortization Schedule.csv';
                            link.style.display = 'none';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          } catch (error) {
                            console.error("Error exporting CSV:", error);

                            // Add this line to see the detailed error information in the console
                            console.error(error.stack);
                          }
                        },
                        exportPdf: (data, columns) => {
                          const doc = new jsPDF();
                          doc.setFont("helvetica", "bold");
                          doc.setFontSize(16);

                          const title = "Amortization Schedule";
                          doc.text(title, 14, 10);

                          doc.setFontSize(12);
                          doc.setFont("helvetica", "normal");
                          const currentDate = new Date().toLocaleDateString();
                          doc.text(`Date : ${currentDate}`, 14, 15);
                          const columnTitles = data.map(
                            (columnDef) => columnDef.title
                          );
                          const space = 22; // Adjust the space value as needed
                          const tableStartY = 5 + space;
                          const pdfData = columns.map((rowData) => {
                            const rowDataArray = data.map((columnDef) => {
                              if (columnDef.field === "paymentAmount") {
                                return (
                                  rowData.paymentAmount !== 0
                                    ? Helper.Amount(rowData.paymentAmount)
                                    : ""
                                );
                              } else if (columnDef.field === 'beginBV') {
                                return (rowData.beginBV !== 0
                                  ? Helper.Amount(rowData.beginBV) : ''
                                )
                              }
                              else if (columnDef.field === 'income') {
                                return (rowData.income !== 0
                                  ? Helper.Amount(rowData.income) : ''
                                )
                              } else if (columnDef.field === 'capitalRecovery') {
                                return (rowData.capitalRecovery !== 0
                                  ? Helper.Amount(rowData.capitalRecovery) : ''
                                )
                              } else if (columnDef.field === 'endBV') {
                                return (rowData.endBV !== 0
                                  ? Helper.Amount(rowData.endBV) : ''
                                )
                              } else if (columnDef.field === 'incomeRecognized') {
                                return (rowData.incomeRecognized !== 0
                                  ? Helper.Amount(rowData.incomeRecognized) : ''
                                )
                              }
                              else {
                                return rowData[columnDef.field];
                              }
                            });
                            return rowDataArray;
                          });
                          // doc.autoTable({
                          autoTable(doc, {
                            head: [columnTitles],
                            body: pdfData,
                            startY: tableStartY, // Adjust the vertical starting position of the table
                            styles: {
                              cellPadding: 2, // Adjust cell padding
                              fontSize: 5,
                            },
                            columnStyles: getAlignmentStyles(data) // Apply column alignment styles
                          });

                          doc.save(`Amortization Schedule.pdf`);
                        },
                        actionsColumnIndex: -1,
                      }}
                    /> :
                    <MaterialTable
                      style={{
                        backgroundColor: "var(--bs-table-bg)",
                        borderBottomWidth: "1px",
                        boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                      }}
                      title={<> <span className="required">Amortization Schedule</span> -{" "}
                        <span style={{ fontSize: "14px" }}>
                          {amortNote}
                        </span>
                        <span>
                          {amortError && (
                            <div className="invalid-feedback" style={{ fontSize: "11px" }}>
                              <strong> Amortization Schedule:</strong> Not generated because IRR is not calculated.<br />
                            </div>
                          )}
                        </span>
                      </>}
                      columns={[
                        {
                          title: `${t("Date")}`,
                          field: "paymentDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("Date")}</div>
                              <div> {Helper.DateNormal(rowData.paymentDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("Payment Amount")}`,
                          field: "paymentAmount",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {t("Payment Amount")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                {" "}
                                {rowData.paymentAmount !== 0
                                  ? Helper.Amount(rowData.paymentAmount)
                                  : ""}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${t("Start Date")}`,
                          field: "startDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("Start Date")}</div>
                              <div>{Helper.DateNormal(rowData.startDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("End Date")}`,
                          field: "endDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("End Date")}</div>
                              <div>{Helper.DateNormal(rowData.endDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("No Of Days")}`,
                          field: "noOfDays",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">{t("No Of Days")}</div>
                              <div>{rowData.noOfDays}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${isLoanLike
                            ? t("Interest Date")
                            : t("Income Date")
                            }`,
                          field: "incomeDate",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {isLoanLike
                                  ? t("Interest Date")
                                  : t("Income Date")}
                              </div>
                              <div>{Helper.DateNormal(rowData.incomeDate)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${isLoanLike
                            ? t("Begining Principal")
                            : t("Begin Bv")
                            }`,
                          field: "beginBV",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {isLoanLike
                                  ? t("Begining Principal")
                                  : t("Begin Bv")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.beginBV)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${isLoanLike ? t("Interest") : t("Income")
                            }`,
                          field: "income",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {isLoanLike
                                  ? t("Interest")
                                  : t("Income")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.income)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },

                        {
                          title: `${t("Capital Recovery")}`,
                          field: "capitalRecovery",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {t("Capital Recovery")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                {Helper.Amount(rowData.capitalRecovery)}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${isLoanLike
                            ? t("Ending Principal")
                            : t("End Bv")
                            }`,
                          field: "endBV",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {isLoanLike
                                  ? t("Ending Principal")
                                  : t("End Bv")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.endBV)}</div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                        {
                          title: `${isLoanLike
                            ? t("Interest Recognized")
                            : t("Income Recognized")
                            }`,
                          field: "incomeRecognized",
                          render: (rowData) => (
                            <>
                              <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                              >
                                {isLoanLike
                                  ? t("Interest Recognized")
                                  : t("Income Recognized")}
                              </div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>
                                {rowData.incomeRecognized !== 0
                                  ? Helper.Amount(rowData.incomeRecognized)
                                  : ""}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },
                      ]}
                      data={setarrears}
                      options={{
                        headerStyle: {
                          backgroundColor: "white",
                          color: "#245C7F",
                          fontSize: 10,
                        },
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: "#fff" };
                          }
                        },
                        sorting: true,
                        search: false,
                        toolbar: true,
                        paging: true,
                        pageSize: 10, // make initial page size
                        emptyRowsWhenPaging: false, // To avoid of having empty rows
                        pageSizeOptions: [10, 15, 20, 50],
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,
                        //export
                        exportAllData: true,
                        exportButton: true,
                        exportFileName: "Amortization Schedule",
                        exportCsv: async (columns, data) => {
                          try {
                            const title = "Amortization Schedule";
                            const currentDate = new Date().toLocaleDateString();

                            const csvContentWithInfo = `${title}\n Date: ${currentDate}\n \n\n`;
                            const csvColumns = columns.map(columnDef => columnDef.title);
                            const csvData = data.map(rowData => {
                              const rowDataArray = columns.map(columnDef => {
                                if (columnDef.field === "paymentAmount") {
                                  return (
                                    rowData.paymentAmount !== 0
                                      ? Helper.Amount(rowData.paymentAmount)
                                      : ""
                                  );
                                } else if (columnDef.field === 'beginBV') {
                                  return (rowData.beginBV !== 0
                                    ? Helper.Amount(rowData.beginBV) : ''
                                  )
                                } else if (columnDef.field === 'income') {
                                  return (rowData.income !== 0
                                    ? Helper.Amount(rowData.income) : ''
                                  )
                                }
                                else if (columnDef.field === 'capitalRecovery') {
                                  return (rowData.capitalRecovery !== 0
                                    ? Helper.Amount(rowData.capitalRecovery) : ''
                                  )
                                } else if (columnDef.field === 'endBV') {
                                  return (rowData.endBV !== 0
                                    ? Helper.Amount(rowData.endBV) : ''
                                  )
                                } else if (columnDef.field === 'incomeRecognized') {
                                  return (rowData.incomeRecognized !== 0
                                    ? Helper.Amount(rowData.incomeRecognized) : ''
                                  )
                                }
                                else {
                                  return rowData[columnDef.field];
                                }
                              });
                              return rowDataArray;
                            });

                            const csvRows = [csvColumns, ...csvData];
                            const csvContent = `${csvContentWithInfo}${csvRows.map(row => {
                              return row.map(field => {
                                if (field === null || field === undefined) {
                                  return '""'; // Represent null values as an empty string in double quotes
                                }
                                field = String(field);
                                if (field.includes(',')) {
                                  return `"${field}"`;
                                } else {
                                  return field;
                                }
                              }).join(',');
                            }).join('\n')}`;
                            // const csvContent = csvRows.map(row => row.join(',')).join('\n');

                            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                            const link = document.createElement('a');
                            link.href = URL.createObjectURL(blob);
                            link.download = 'Amortization Schedule.csv';
                            link.style.display = 'none';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          } catch (error) {
                            console.error("Error exporting CSV:", error);

                            // Add this line to see the detailed error information in the console
                            console.error(error.stack);
                          }
                        },
                        exportPdf: (data, columns) => {
                          const doc = new jsPDF();
                          doc.setFont("helvetica", "bold");
                          doc.setFontSize(16);

                          const title = "Amortization Schedule";
                          doc.text(title, 14, 10);

                          doc.setFontSize(12);
                          doc.setFont("helvetica", "normal");
                          const currentDate = new Date().toLocaleDateString();
                          doc.text(`Date : ${currentDate}`, 14, 15);
                          const columnTitles = data.map(
                            (columnDef) => columnDef.title
                          );
                          const space = 22; // Adjust the space value as needed
                          const tableStartY = 5 + space;
                          const pdfData = columns.map((rowData) => {
                            const rowDataArray = data.map((columnDef) => {
                              if (columnDef.field === "paymentAmount") {
                                return (
                                  rowData.paymentAmount !== 0
                                    ? Helper.Amount(rowData.paymentAmount)
                                    : ""
                                );
                              } else if (columnDef.field === 'beginBV') {
                                return (rowData.beginBV !== 0
                                  ? Helper.Amount(rowData.beginBV) : ''
                                )
                              } else if (columnDef.field === 'income') {
                                return (rowData.income !== 0
                                  ? Helper.Amount(rowData.income) : ''
                                )
                              } else if (columnDef.field === 'capitalRecovery') {
                                return (rowData.capitalRecovery !== 0
                                  ? Helper.Amount(rowData.capitalRecovery) : ''
                                )
                              } else if (columnDef.field === 'endBV') {
                                return (rowData.endBV !== 0
                                  ? Helper.Amount(rowData.endBV) : ''
                                )
                              } else if (columnDef.field === 'incomeRecognized') {
                                return (rowData.incomeRecognized !== 0
                                  ? Helper.Amount(rowData.incomeRecognized) : ''
                                )
                              }
                              else {
                                return rowData[columnDef.field];
                              }
                            });
                            return rowDataArray;
                          });
                          // doc.autoTable({
                          autoTable(doc, {
                            head: [columnTitles],
                            body: pdfData,
                            startY: tableStartY, // Adjust the vertical starting position of the table
                            styles: {
                              cellPadding: 2, // Adjust cell padding
                              fontSize: 5,
                            },
                            columnStyles: getAlignmentStyles(data) // Apply column alignment styles
                          });

                          doc.save(`Amortization Schedule.pdf`);
                        },
                        actionsColumnIndex: -1,
                      }}
                    />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AmortizationScheduleArrears;
